module.exports = {
    alphanum: require('./alphanum'),
    match   : require('./match'),
    guid   : require('./guid'),
    // email   : require('./email'),
    numeric   : require('./numeric')
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/is/index.js
 ** module id = 832
 ** module chunks = 0
 **/